/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Witty_Proud_Mole_Filter_CycleInputs */

const fr_witty_proud_mole_filter_cycle = /** @type {(inputs: Witty_Proud_Mole_Filter_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cycle`)
};

/**

* @param {Witty_Proud_Mole_Filter_CycleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const witty_proud_mole_filter_cycle = /** @type {((inputs?: Witty_Proud_Mole_Filter_CycleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Witty_Proud_Mole_Filter_CycleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_witty_proud_mole_filter_cycle(inputs)
});